import React from 'react';
import { connect } from 'react-redux';
import { Link as v4Link } from 'react-router-dom';
import numberUtils from 'app/shared/utils/numberUtils';

// Constants
import BillingConstants from 'app/shared/constants/BillingConstants';

// Multibrand-UI Components
import Link from '@zg-rentals/multibrand-ui/lib/Link';

// Selectors
import { UserSelectors, AppSelectors } from 'app/shared/selectors';

// Actions
import BillingActions from 'app/shared/actions/BillingActions';

// Components
import BillingInvoicePage from 'app/shared/components/Billing/BillingInvoicePage';

import PropertyNameList from 'app/shared/containers/BillingPage/PropertyNameList';

const invoiceRenderer = invoice => (invoice.invoiceType !== BillingConstants.INVOICE_TYPES.NUCLEUS_LISTING
    ? (
        <Link reactRouterLink={v4Link} to={`/rental-manager/billing/invoice/${invoice.invoiceNumber}`}>
            {invoice.invoiceNumber}
        </Link>
    )
    : (
        <span>
            {invoice.invoiceNumber}
        </span>
    ));

const fullColumnConfig = [
    {
        dataKey: 'invoiceDate',
        width: 2,
        header: 'Date',
        renderer: invoice => invoice.invoiceDate && (new Date(invoice.invoiceDate)).toLocaleDateString(),
    },
    {
        width: 2,
        header: 'Invoice No.',
        dataKey: 'invoiceNumber',
        renderer: invoiceRenderer,
        className: 'TableMFH-data-word-break',
    },
    {
        width: 2,
        header: 'Properties',
        dataKey: 'propertyNames',
        renderer: invoice => <PropertyNameList invoice={invoice} />,
    },
    {
        width: 2,
        header: 'Amount',
        dataKey: 'amount',
        renderer: invoice => numberUtils.asCurrency(invoice.amount, '$0,0.00'),
        align: 'right',
    },
    {
        width: 2,
        header: 'Status',
        dataKey: 'balance',
        renderer: invoice => (invoice.balance === 0 ? 'Paid' : 'Partially Paid'),
        align: 'center',
    },
];

const mobileColumnConfig = [
    {
        dataKey: 'invoiceDate',
        width: 3,
        header: 'Date',
        renderer: invoice => invoice.invoiceDate && (new Date(invoice.invoiceDate)).toLocaleDateString(),
    },
    {
        width: 4,
        header: 'Invoice No.',
        dataKey: 'invoiceNumber',
        renderer: invoiceRenderer,
        className: 'TableMFH-data-word-break',
    },
    {
        width: 3,
        header: 'Status',
        dataKey: 'balance',
        renderer: invoice => (invoice.balance === 0 ? 'Paid' : 'Partially Paid'),
        align: 'center',
    },
];

const mapStateToProps = state => ({
    user: UserSelectors.makeUser(state),
    loadingState: state.billing.invoicesPaid.loadingState,
    errorMsg: state.billing.invoice.currentInvoiceErrorMessage,
    filters: state.billing.invoicesPaid.filters,
    invoices: state.billing.invoicesPaid.invoices,
    hasMoreData: state.billing.invoicesPaid.hasMoreData,
    isScreenMobile: AppSelectors.makeIsScreenMobile(state),
    isFilterEnabled: state.billing.invoicesPaid.isFilterEnabled,
    lastZuoraSyncTime: state.billing.invoicesPaid.lastZuoraSyncTime,
    fullColumnConfig,
    mobileColumnConfig,
    emptyMessage: BillingConstants.EMPTY_NOTIFICATIONS.NO_PAID_INVOICES,
    title: 'Paid Invoices',
    cookieEnabledServices: AppSelectors.makeCookieEnabledServices(state),
    showHistory: true,
});

const mapDispatchToProps = {
    fetchBillingData: BillingActions.invoicesPaid.fetchBillingData,
    fetchPropertyData: BillingActions.invoicesPaid.fetchPropertyData,
    clearInvoices: BillingActions.invoicesPaid.clearInvoices,
    setFilters: BillingActions.invoicesPaid.setFilters,
};

export { BillingInvoicePage as PaidInvoicesPage };
export default connect(mapStateToProps, mapDispatchToProps)(BillingInvoicePage);
